import { Link } from "react-router-dom";
import { LogoLockup } from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#1E1B7A]/10 bg-white/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <LogoLockup size={36} />
          <p className="text-sm text-[#64748B] leading-relaxed mt-5">
            AI-crafted Vedic wisdom, made simple. Reports delivered instantly for ₹699.
          </p>
        </div>
        <div>
          <h3 className="text-sm text-[#1E1B4B] mb-3 font-semibold">Premium</h3>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/reports/vedic" className="hover:text-[#1E1B7A]">Vedic Astrology</Link></li>
            <li><Link to="/reports/palmistry" className="hover:text-[#1E1B7A]">Palmistry</Link></li>
            <li><Link to="/reports/tarot" className="hover:text-[#1E1B7A]">Tarot Reading</Link></li>
            <li><Link to="/reports/numerology" className="hover:text-[#1E1B7A]">Numerology</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm text-[#1E1B4B] mb-3 font-semibold">Reports</h3>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/reports/love" className="hover:text-[#1E1B7A]">Love Report</Link></li>
            <li><Link to="/reports/career" className="hover:text-[#1E1B7A]">Career Report</Link></li>
            <li><Link to="/reports/wealth" className="hover:text-[#1E1B7A]">Wealth Report</Link></li>
            <li><Link to="/reports/compatibility" className="hover:text-[#1E1B7A]">Compatibility</Link></li>
            <li><Link to="/angel-numbers" className="hover:text-[#1E1B7A]">Angel Numbers</Link></li>
            <li><Link to="/compatibility" className="hover:text-[#1E1B7A]">Compatibility Atlas</Link></li>
            <li><Link to="/astrologer" className="hover:text-[#1E1B7A]">Astrologer near you</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm text-[#1E1B4B] mb-3 font-semibold">Company</h3>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-[#1E1B7A]">About</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#1E1B7A]">Privacy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-[#1E1B7A]">Terms</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#1E1B7A]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1E1B7A]/10 py-6 text-center text-xs text-[#64748B]">
        © {new Date().getFullYear()} Bhavishyavani. AI-generated content for reflection and guidance.
      </div>
    </footer>
  );
}
